import { setTagTransformer } from '@zafire/react/tag-transformer';

setTagTransformer((tag: string) => (tag.startsWith('zf-') ? `clm-portal-${tag}` : tag));
